import { z, isoZ } from 'my-zod'
import { GeneralAddressFragment } from '../address'

export const ReservationEventAttachmentDto = z.object({
  reservationUrl: z.string(),
  catalogItemName: z.string(),

  beginZonedDateTime: isoZ.zonedDateTime(),
  endZonedDateTime: isoZ.zonedDateTime(),

  addressLine1: GeneralAddressFragment.shape.addressLine1,
  addressLine2: GeneralAddressFragment.shape.addressLine2,
  city: GeneralAddressFragment.shape.city,
  state: GeneralAddressFragment.shape.stateProvince,
  zipCode: GeneralAddressFragment.shape.postalCode
})

export type ReservationEventAttachmentDto = z.infer<typeof ReservationEventAttachmentDto>
